import styled from 'styled-components';

export const Item = styled.div<{
  width?: string;
  height?: string;
  borderRadius?: string;
}>`
  width: ${({ width }) => width ?? '2rem'};
  height: ${({ height }) => height ?? '2rem'};
  border-radius: ${({ borderRadius }) => borderRadius ?? '50%'};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  cursor: pointer;
`;

export const ItemDisplayContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
`;

export const SizeItem = styled(Item)<{
  available: boolean;
  selected: boolean;
  fontSize?: string;
  hasNoBackground?: boolean;
}>`
  border: ${({ theme, hasNoBackground }) =>
    hasNoBackground ? 'none' : `0.0625rem solid ${theme.colors.primaryDark}`};

  p {
    font-size: ${({ fontSize }) => fontSize ?? '0.5rem'};
    line-height: 1rem;
    color: ${({ theme }) => theme.colors.primaryDark};
    font-weight: 400;
  }
  ${({ available }) => !available && `cursor: not-allowed;`}
  ${({ available }) => !available && `opacity: 0.5;`}
  ${({ available, hasNoBackground, theme }) =>
    available &&
    `
      &:hover {
        cursor: pointer;
        background: ${
          hasNoBackground ? 'transparent' : theme.colors.primaryDark
        };

        p {
          color: ${
            hasNoBackground ? theme.colors.primaryDark : theme.colors.primary
          };
        }
      }
  `}

  ${({ selected, hasNoBackground, theme }) =>
    selected &&
    `
    background: ${hasNoBackground ? 'transparent' : theme.colors.primaryDark};
    p {
      color: ${
        hasNoBackground ? theme.colors.primaryDark : theme.colors.primary
      };
    }
  }
  `}
`;

export const ColorItem: React.FC<{
  color: string;
  available: boolean;
  selected: boolean;
  width?: string;
  height?: string;
}> = ({ color, available, selected, height, width }) => {
  const colors = color.split('/');

  const getBackground = () => {
    switch (colors.length) {
      case 1:
        return `#${colors[0]}`; // Single color
      case 2:
        return `linear-gradient(to right, #${colors[0]} 0, #${colors[0]} 50%, #${colors[1]} 50%, #${colors[1]} 100%)`; // Two colors split vertically
      case 3:
        return `linear-gradient(to right, #${colors[0]} 0, #${colors[0]} 33%, #${colors[1]} 33%, #${colors[1]} 66%, #${colors[2]} 66%, #${colors[2]} 100%)`; // Three colors divided equally
      default:
        return `#${colors[0]}`;
    }
  };
  return (
    <StyledColorItem
      color={getBackground()}
      available={available}
      selected={selected}
      width={width}
      height={height}
    />
  );
};

const StyledColorItem = styled(Item)<{
  color: string;
  available: boolean;
  selected: boolean;
  width?: string;
  height?: string;
}>`
  background: ${(props) => props.color};
  background-origin: border-box;
  border: 0.125rem solid #404d5621;
  width: ${(props) => props.width || ''};
  height: ${(props) => props.height || ''};
`;
